<template>
  <Select
    v-model="item.value"
    :placeholder="item.placeholder"
    :disabled="readonly || item.disabled"
    :multiple="item.multiple"
    @on-change="(val) => item.onChange && item.onChange(val, item, formItems)"
    :class="{ readonly: readonly }"
    transfer
    :filterable="item.filterable"
  >
    <Option v-for="o in (item.options || [])" :key="o.value" :value="o.value">{{o.text}}</Option>
  </Select>
</template>
<script>
import props from './props'
export default {
  name: 'form-item-select',
  mixins: [props],
  data () {
    return {}
  }
}
</script>